// extracted by mini-css-extract-plugin
export default {"verify_view":"verify-view_verify_view__3Vb5D"};